import { DecimalPipe } from '@angular/common';
import { BalanceMoneyPipe } from 'shared/pipes/balance-money.pipe';
import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';
import { ISpecialPaymentMemberContribution } from 'core/types/balance-transaction.interface';
import { UserAvatarComponent } from '../../user-avatar/user-avatar.component';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-total-contribution-list',
  standalone: true,
  imports: [DecimalPipe, BalanceMoneyPipe, UserAvatarComponent, TranslateModule],
  templateUrl: './total-contribution-list.component.html',
  styleUrl: './total-contribution-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TotalContributionListComponent {
  private readonly _translateService = inject(TranslateService);

  readonly list = input<ISpecialPaymentMemberContribution[]>([]);
  // korviu-list binds this for every item type; the design gives these rows no action, so it never fires.
  readonly userClick = output<ISpecialPaymentMemberContribution>();

  readonly language = toSignal(this._translateService.onLangChange.pipe(map(event => event.lang)), {
    initialValue: this._translateService.getCurrentLang() || 'es'
  });

  public getInitials(member: ISpecialPaymentMemberContribution): string {
    return (member.full_name ?? '')
      .split(/\s+/u)
      .filter(Boolean)
      .slice(0, 2)
      .map(part => part.charAt(0).toUpperCase())
      .join('');
  }

  public getAvatarUrl(member: ISpecialPaymentMemberContribution): string {
    return member.avatar?.image ? environment.avatarsUrl + 'Property_1=' + member.avatar.image : '';
  }

  public getContribution(member: ISpecialPaymentMemberContribution): number | null {
    const amount = Number(member.contribution);
    return member.contribution == null || !Number.isFinite(amount) ? null : amount;
  }
}
